module.exports = __webpack_public_path__ + "static/media/clock-off.fc471cbf.svg";